import { t } from 'i18next';

import { UsersOptions } from 'system/constants';

export const getTitleForConfirmation = (option: UsersOptions) => {
  switch (option) {
    case UsersOptions.BLOCK:
      return t('labelBlockUser');
    case UsersOptions.UNBLOCK:
      return t('labelUnblockUser');
    case UsersOptions.BLOCK_IP:
      return t('labelBlockUserIp');
    case UsersOptions.UNBLOCK_IP:
      return t('labelUnblockUserIp');
    case UsersOptions.REMOVE_ASSIGNED_COMPANY:
      return t('labelRemoveAssignedCompany');
    default:
      return '';
  }
};

export const getConfirmationMessage = (option: UsersOptions, selectedRows) => {
  const action = [UsersOptions.BLOCK, UsersOptions.BLOCK_IP].includes(option) ? 'block' : 'unblock';

  switch (option) {
    case UsersOptions.BLOCK:
    case UsersOptions.UNBLOCK:
      if (selectedRows?.length > 1) {
        return t('messageConfirmBlockUnblockUsers', {
          action,
          userLength: selectedRows.length,
        });
      }

      return t('messageConfirmBlockUnblockUser', {
        action,
        userName: selectedRows?.[0]?.name,
      });
    case UsersOptions.BLOCK_IP:
    case UsersOptions.UNBLOCK_IP:
      if (selectedRows?.length > 1) {
        return t('messageConfirmBlockUnblockUserIPs', {
          action,
          userLength: selectedRows.length,
        });
      }

      return t('messageConfirmBlockUnblockUserIP', {
        action,
        userName: selectedRows?.[0]?.name,
      });
    case UsersOptions.REMOVE_ASSIGNED_COMPANY:
      if (selectedRows?.length > 1) {
        return t('messageConfirmRemoveAssignedCompanyForSelectedUsers', {
          userLength: selectedRows.length,
        });
      }

      return t('messageConfirmRemoveAssignedCompanyForUser', {
        userName: selectedRows?.[0]?.name,
      });
    default:
      return '';
  }
};

export const getConfirmationButtonText = (option: UsersOptions) => {
  switch (option) {
    case UsersOptions.BLOCK:
      return t('buttonLabelBlock');
    case UsersOptions.UNBLOCK:
      return t('buttonLabelUnblock');
    case UsersOptions.BLOCK_IP:
      return t('buttonLabelBlockIp');
    case UsersOptions.UNBLOCK_IP:
      return t('buttonLabelUnblockIp');
    case UsersOptions.REMOVE_ASSIGNED_COMPANY:
      return t('buttonLabelRemoveAssignedCompany');
    default:
      return '';
  }
};
